import { call, put, takeEvery } from "redux-saga/effects";
import { getPricingTiers, getTip, getUserCoupon } from "../../api/tips";
import { tipsActions } from "../../store/tips/actions";
import {
  COUPON_REQUEST,
  PRICING_TIERS_REQUEST,
  TIP_PRODUCT_REQUEST,
} from "../../constants/tips";

function* pricingTiersRequestSaga(): any {
  try {
    const pricingTiers = yield call(getPricingTiers);
    yield put(tipsActions.pricingTiersSuccessAction(pricingTiers));
  } catch (e: any) {
    yield put(tipsActions.pricingTiersFailureAction(e));
  }
}
export function* CouponRequestSaga(): any {
  try {
    const coupon = yield call(getUserCoupon);
    yield put(tipsActions.couponSuccessAction(coupon));
  } catch (e: any) {
    yield put(tipsActions.couponFailureAction(e));
  }
}
export function* TipProductRequestSaga(data: any): any {
  try {
    const tip = yield call(getTip, data.payload);
    yield put(tipsActions.tipProductSuccessAction(tip));
  } catch (e: any) {
    yield put(tipsActions.tipProductFailureAction(e));
  }
}

export function* tipsInfoSaga() {
  yield takeEvery(PRICING_TIERS_REQUEST, pricingTiersRequestSaga);
  yield takeEvery(COUPON_REQUEST, CouponRequestSaga);
  yield takeEvery(TIP_PRODUCT_REQUEST, TipProductRequestSaga);
}
